module.exports = __webpack_public_path__ + "img/showlive.c7f82ad3.png";